import { MRT_ColumnDef } from "material-react-table"
import { colors } from "../../../styles/commonStyles"
import { Box } from "@mui/material"
interface ColumnData {
  column_id: string
  column_name: string
}

export const percentFormatter = ({ renderedCellValue, row }: any) => {
  return `${parseFloat(renderedCellValue || "0").toFixed(2)} %`
}
export const amountFormatter = ({ renderedCellValue }: any) =>
  renderedCellValue
    ? `$ ${parseInt(renderedCellValue || "0")
        .toLocaleString
        //   undefined,
        //   {
        //   minimumFractionDigits: 2,
        //   maximumFractionDigits: 2,
        // }
        ()}`
    : renderedCellValue

export const createColumn = (): MRT_ColumnDef<any>[] => [
  {
    header: "Transaction Date",
    accessorKey: "transaction_date",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Transaction Type",
    accessorKey: "transaction_type",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Transaction Number",
    accessorKey: "transaction_number",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Transaction Name",
    accessorKey: "transaction_name",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Class",
    accessorKey: "transaction_class",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Memo",
    accessorKey: "transaction_memo",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue,
    muiTableBodyCellProps: {},
  },
  {
    header: "Amount",
    accessorKey: "transaction_amount",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
]

export const createSummaryColumn = (): MRT_ColumnDef<any>[] => [
  {
    header: "Doctor",
    accessorKey: "doctor",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue || "0",
    muiTableBodyCellProps: {},
  },
  {
    header: "Period",
    accessorKey: "period",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue || "0",
    muiTableBodyCellProps: {},
  },
  {
    header: "Doc Comp Plan",
    accessorKey: "comp_plan_base",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue || "0",
    muiTableBodyCellProps: {},
  },
  {
    header: "Comp Plan Base Amount",
    accessorKey: "base_amount",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) =>
      `$ ${Number(renderedCellValue).toLocaleString()}`,
    muiTableBodyCellProps: {},
  },
  {
    header: "Total Gross Commissions (Summary of Tier 1-5)",
    accessorKey: "total_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  // {
  //   header: "Gross Commission",
  //   accessorKey: "gross_commission",
  //   muiTableHeadCellProps: {
  //     align: "left",
  //   },
  //   Cell: amountFormatter,
  //   muiTableBodyCellProps: {},
  // },
  {
    header: "Lab Expense",
    accessorKey: "lab_expense",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Lab %",
    accessorKey: "lab_percent",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => `${renderedCellValue} %`,
    muiTableBodyCellProps: {},
  },
  {
    header: "Lab Deduction (Lab Expense x Lab %)",
    accessorKey: "lab_deduction",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },

  {
    header: "Net Commission (Gross Commission - Lab Deduction)",
    accessorKey: "commission_rate",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Payroll/Paid",
    accessorKey: "payroll",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "True Up",
    accessorKey: "true_up",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: (cell: any) => <Box>{amountFormatter(cell)}</Box>,
    muiTableBodyCellProps: ({ cell }: any) => ({
      sx: {
        padding: "0px 2%",
        "& div": {
          display: "flex",
          margin: "auto",
          justifyContent: "center",
          whiteSpace: "nowrap",
          // padding: "5%",
          // border:
          //   cell.getValue() > 0 ? "1px solid #FFFFFF" : "1px solid #E4E4E4",
          backgroundColor: cell.getValue() < 0 ? colors.primaryRed : "#FFFFFF",
          color: cell.getValue() < 0 ? colors.primaryWhite : "black",
        },
      },
    }),
  },
  {
    header: "Tier 1 Gross Commissions",
    accessorKey: "tier_1_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Tier 2 Gross Commissions",
    accessorKey: "tier_2_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Tier 3 Gross Commissions",
    accessorKey: "tier_3_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Tier 4 Gross Commissions",
    accessorKey: "tier_4_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Tier 5 Gross Commissions",
    accessorKey: "tier_5_gross_commissions",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: amountFormatter,
    muiTableBodyCellProps: {},
  },
  {
    header: "Reconciled",
    accessorKey: "reconciled",
    muiTableHeadCellProps: {
      align: "left",
    },
    Cell: ({ cell, renderedCellValue }) => renderedCellValue || "-",
    muiTableBodyCellProps: {},
  },
]
